import { Component } from '@angular/core';
import { StorageService } from '../../services/storage/storage.service';
import { SESSION_DEPARTMENT_LIST, SESSION_OPERATION_MODE } from '../../app.constants';
import { CartService } from '../../services/cart/cart.service';
import { Cart } from '../../models/cart.model';
import { ItemListService } from '../../services/shared/item-list.service';
import { OOModule } from '../../modules/oo.module';
import { MatModule } from '../../modules/mat.module';
import { MatTabsModule } from '@angular/material/tabs';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-operation-mode-header',
  imports: [OOModule, MatModule, MatTabsModule, CommonModule, RouterModule],
  templateUrl: './operation-mode-header.component.html',
  styleUrl: './operation-mode-header.component.scss'
})
export class OperationModeHeaderComponent {
  instoreMode: any;
  preparationTime: any;
  cart: Cart;
  saleItemList: any;
  deliveryMethod: any;
  deliveryDate: any;
  deliveryDateTime: string;
  selectedShop: any;
  deliveryTime: any;
  qrInfo: any;

  constructor(private storageService: StorageService,
    private cartService: CartService,
    private itemListService: ItemListService,
    private router: Router,
  ) {
    this.cart = this.cartService.cart;
    this.saleItemList = this.itemListService.saleItemList;
    const businessType = this.cart.businessType;
    this.preparationTime = businessType.initialDelay;
    // console.log(this.saleItemList)
    // this.customizationDetail = [];
    const departmentList = JSON.parse(this.storageService.loadFromSession(SESSION_DEPARTMENT_LIST));
    const commonDept = departmentList.find((dept: any) => dept.code === 'COMMON');

    this.selectedShop = this.cartService.getShop();
    this.deliveryDate = this.cartService.getDeliveryDate();
    this.deliveryTime = this.cartService.getDeliveryTime();

    this.deliveryMethod = this.cartService.getService();
    this.deliveryDateTime = this.deliveryDate.date + " " + this.deliveryTime;


    const mode = JSON.parse(this.storageService.loadFromSession(SESSION_OPERATION_MODE));
    if (mode !== null && mode !== undefined && mode.length !== 0) {
      this.qrInfo = mode;
      // console.log(this.qrInfo.table)
      this.instoreMode = true;
    } else {
      this.instoreMode = false;
    }
  }

  ngOnInit() {

  }

  navigateToshopList() {
    this.router.navigate(['/shopList']);
  }
}
